import UpdateWorker from "../../../../components/@users/workers/UpdateWorker";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function WorkerUpdatePage() {

    return (
        <UpdateWorker 
            routeType={routeTypes.admin}
        />
    )
}       